import {
    LISTILT_REQUEST,
    LISTILT_ERROR,
    LISTILT_SUCCESS,
    LISTILT_params
} from "../actions/listILT";
import apiCalls from "utils/api";
import store from '../../store';
import Vue from "vue";

const state = {
    listILT: [],
    listILTstatus: "",
};

const getters = {
    getListILT: state => state.listILT,
    isListILTLoaded: state => !!state.listILT,
    getListILTstatus: state => state.listILTstatus,

    getTotals: state => {
        const reducer = (accumulator, currentValue) => accumulator + currentValue;

        var loaded = state.listILT.filter(it => it.Type === 'Loaded').map(m => m.Weight);
        var returns = state.listILT.filter(it => it.Type === 'Return').map(m => m.Weight);
        var unloaded = state.listILT.filter(it => it.Type === 'Deliver').map(m => m.Weight);

        return {
            Loaded: {
                quantity: loaded.length,
                total: loaded.length ? loaded.reduce(reducer) : 0
            },
            Returns: {
                quantity: returns.length,
                total: returns.length ? returns.reduce(reducer) : 0
            },
            Unloaded: {
                quantity: unloaded.length,
                total: unloaded.length ? unloaded.reduce(reducer) * -1 : 0
            },
            Current: {
                quantity: loaded.length
                    + returns.length
                    - unloaded.length,

                total: state.listILT.map(m => m.Weight).length ? state.listILT.map(m => m.Weight).reduce(reducer) : 0
            },
        }
    },

    //getLoaded: state => {
    //    var data = state.listILT.filter(it => {
    //        return it.Type === 'Loaded'
    //    }).reduce(function (r, o) {

    //        if (r.find(f => f.Product == o.Product)) {
    //            r.find(f => f.Product == o.Product).Weight += o.Weight;
    //            r.find(f => f.Product == o.Product).Quantity++;
    //        }
    //        else
    //            r.push({
    //                Product: o.Product,
    //                Weight: o.Weight,
    //                Quantity: 1,
    //                UN: o.UN,
    //                Unit: o.Unit
    //            });

    //        return r;
    //    }, []);

    //    var totals = data.map(m => m.Weight);
    //    var total = 0;
    //    totals.forEach(f => total += f);

    //    return {
    //        data: data,
    //        total: total
    //    }
    //},

    //getReturn: state => {
    //    var data = state.listILT.filter(it => {
    //        return it.Type === 'Return'
    //    }).reduce(function (r, o) {

    //        if (r.find(f => f.Product == o.Product)) {
    //            r.find(f => f.Product == o.Product).Weight += o.Weight;
    //            r.find(f => f.Product == o.Product).Quantity++;
    //        }
    //        else
    //            r.push({
    //                Product: o.Product,
    //                Weight: o.Weight,
    //                Quantity: 1,
    //                UN: o.UN,
    //                Unit: o.Unit
    //            });

    //        return r;
    //    }, []);

    //    var totals = data.map(m => m.Weight);
    //    var total = 0;
    //    totals.forEach(f => total += f);

    //    return {
    //        data: data,
    //        total: total
    //    }
    //},

    //getDeliver: state => {
    //    var data = state.listILT.filter(it => {
    //        return it.Type === 'Deliver'
    //    }).reduce(function (r, o) {
    //        if (r.find(f => f.Product == o.Product)) {
    //            r.find(f => f.Product == o.Product).Weight += o.Weight;
    //            r.find(f => f.Product == o.Product).Quantity++;
    //        }
    //        else
    //            r.push({
    //                Product: o.Product,
    //                Weight: o.Weight,
    //                Quantity: 1,
    //                UN: o.UN,
    //                Unit: o.Unit
    //            });

    //        return r;
    //    }, []);
    //    var totals = data.map(m => m.Weight);
    //    var total = 0;
    //    totals.forEach(f => total += f);
    //    return {
    //        data: data,
    //        total: total
    //    }
    //}
};

const actions = {
    [LISTILT_REQUEST]: ({ commit, dispatch }) => {
        commit(LISTILT_REQUEST);
        var tripLineId = null;

        if (store.state.ordersList.ordersList.length > 0)
            tripLineId = store.state.ordersList.ordersList[0].TripLineId;

        var filter = [
            {
                Filters: [
                    {
                        name: 'TripLineId',
                        value: tripLineId,
                        operator: '='
                    }
                ]
            }
        ];

        LISTILT_params.filter = JSON.stringify(filter);

        apiCalls.apiCall({ url: "get", method: "GET", params: LISTILT_params })
            .then(resp => {
                commit(LISTILT_SUCCESS, resp.data);
            })
            .catch(() => {
                commit(LISTILT_ERROR);
            });
    }
};

const mutations = {
    [LISTILT_REQUEST]: state => {
        state.listILTstatus = "loading";
    },
    [LISTILT_SUCCESS]: (state, resp) => {
        state.listILTstatus = "success";
        state.listILT = resp.data;
        Vue.set(state, "listILT", resp.data);
    },
    [LISTILT_ERROR]: state => {
        state.listILTstatus = "error";
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
